import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "select2-drpdwn" }
const _hoisted_3 = { class: "row" }

import { defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'indexSelect',
  setup(__props) {

const selectView = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/select2/selectView.vue"))
const outlineColor = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/select2/outlineColor.vue"))
const fullColored = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/select2/fullColored.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Form Widgets",
      title: "Select2"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(selectView)),
          _createVNode(_unref(outlineColor)),
          _createVNode(_unref(fullColored))
        ])
      ])
    ])
  ], 64))
}
}

})